/**
 * Copyright (c) 2022 - Present. Blend Labs, Inc. All rights reserved
 * Blend Confidential - Restricted
 */
import { Header as ECHeader } from '@blend/enterprise-components';
import { css, StyleSheet } from 'aphrodite';
import React, { ReactNode } from 'react';

const styles = StyleSheet.create({
  wrapper: {
    paddingTop: 32,
    paddingBottom: 16,
  },
});

export namespace TabSectionHeader {
  export interface Props {
    children: ReactNode;
  }
}

export const TabSectionHeader: React.FC<TabSectionHeader.Props> = ({ children }) => {
  return (
    <div className={css(styles.wrapper)} data-dd-privacy="allow">
      <ECHeader size={4} fontWeight="MEDIUM">
        {children}
      </ECHeader>
    </div>
  );
};
